__webpack_require__.p = "/Judging-the-Judges.github.io/";